import { DEMO_RESET_EVENT } from "./demo-session";

export type TelemedicineDemoRecord = {
  consentSimulated: boolean;
  orientationSimulated: boolean;
};

export type TelemedicineDemoSession = Record<string, TelemedicineDemoRecord>;

export const TELEMEDICINE_DEMO_SESSION_KEY = "yatta:telemedicine-demo:v1";

export function readTelemedicineDemoSession(): TelemedicineDemoSession {
  if (typeof window === "undefined") return {};

  try {
    const stored = window.sessionStorage.getItem(TELEMEDICINE_DEMO_SESSION_KEY);
    if (!stored) return {};

    const value: unknown = JSON.parse(stored);
    if (typeof value !== "object" || value === null || Array.isArray(value)) return {};

    return Object.fromEntries(
      Object.entries(value).flatMap(([id, record]) => {
        if (typeof record !== "object" || record === null || Array.isArray(record)) return [];
        const candidate = record as Partial<TelemedicineDemoRecord>;
        if (
          typeof candidate.consentSimulated !== "boolean" ||
          typeof candidate.orientationSimulated !== "boolean"
        )
          return [];
        return [[id, candidate as TelemedicineDemoRecord]];
      }),
    );
  } catch {
    return {};
  }
}

export function writeTelemedicineDemoSession(session: TelemedicineDemoSession) {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(TELEMEDICINE_DEMO_SESSION_KEY, JSON.stringify(session));
}

export function clearTelemedicineDemoSession() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(TELEMEDICINE_DEMO_SESSION_KEY);
}

if (typeof window !== "undefined") {
  window.addEventListener(DEMO_RESET_EVENT, clearTelemedicineDemoSession);
}
